import { Role } from '../models/role'
import { RouterUtil } from 'kuaidong-lib'
import { CompetitionMode } from 'kuaidong-model'
import competitionRegionOrganizationRoutes from './RCompetitionRegionOrganization'

export default RouterUtil.cloneRoutes(
  competitionRegionOrganizationRoutes,
  'video',
  '区域视频赛',
  {
    mode: CompetitionMode.Video,
  },
  [Role.Organization, Role.OrganizationJudge]
)
